import {APIDirectory , HTTP} from '../../rest'
import { constant } from "./PricingActionConstants";

export const getSubscriptionPlansInProgress = () => {
    return{
    type:constant.GET_SUBSCIPTION_PLANS_IN_PROGRESS
}}

export const getSubscriptionPlansComplete =(data) => {
    return{
        type:constant.GET_SUBSCIPTION_PLANS_COMPLETE,
        data:data
    }
}

export const getSubscriptionPlans = () =>
{  
    return async dispatch => {
        try{
            dispatch(getSubscriptionPlansInProgress());
            let url = APIDirectory.getSubscriptionPlansURL();
            let plans = await HTTP.GET(url);
            dispatch(getSubscriptionPlansComplete(plans));
            return plans;
        }
        catch(error){
            return[];
        }

    }
}





